import {Typography} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {MdOutlineArrowForwardIos} from 'react-icons/md';

import type {Props} from '../types';

const NestedMenu = (props: Props) => {
  const {open, anchorEl, menuItems = [], handleMenuClose} = props || {};
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      id="menu-nested-list-grow"
      placement="bottom-start"
      sx={{
        paddingTop: '5px',
        width: '200px',
      }}
    >
      <Paper>
        <MenuList>
          {menuItems.map((item, index) => (
            <MenuItem
              key={`lotus-menu-menuitem-${index}`}
              onClick={handleMenuClose}
            >
              <Typography variant="inherit">{item.label}</Typography>
              <MdOutlineArrowForwardIos style={{marginLeft: 'auto'}} />
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </Popper>
  );
};

export default NestedMenu;
